import { api } from './client'

/**
 * Blocco 1 / Card D (REQ-155-001, 156-001, 195-001, 196-001) — scenari di liquidita' (prudente / realistico / ottimistico),
 * "quanto possiamo spendere" e simulatore economico. Forme pinnate nel brief. Se conti e' spento il server risponde
 * `available: false` con un motivo (mai un errore). Gli importi mancano per chi non ha `CanSeeRealAmounts`.
 */

export type ScenarioCode = 'prudente' | 'realistico' | 'ottimistico'

export const SCENARIO_LABELS: Record<ScenarioCode, string> = {
  prudente: 'Prudente',
  realistico: 'Realistico',
  ottimistico: 'Ottimistico',
}

export interface ScenarioPeriod {
  start: string
  end: string
  in: number
  out: number
  balance: number
}

export interface CashScenario {
  code: ScenarioCode
  periods: ScenarioPeriod[]
  minBalance: number
  breachDate: string | null
}

export interface TreasuryScenarios {
  available: boolean
  reason: string | null
  asOf: string | null
  liquidity?: number | null
  minimumReserve?: number | null
  scenarios: CashScenario[]
}

export type ScenarioGroupBy = 'day' | 'week' | 'month'

export interface SpendSimulationPoint {
  minBalance: number
  breachDate: string | null
}

export interface SpendSimulation {
  before: SpendSimulationPoint
  after: SpendSimulationPoint
  periods: ScenarioPeriod[]
}

export interface EconomicSimulatorInput {
  monthlyProduction: number
  marginPct: number
  fixedCosts: number
  variableCosts: number
  commissions: number
  months: number
}

export interface EconomicSimulatorMonth {
  margin: number
  cashFlow: number
  taxesEstimated: number
  liquidity: number
  freeLiquidity: number
}

export interface EconomicSimulatorResult {
  months: EconomicSimulatorMonth[]
  taxesLabel: string
}

export const treasuryScenariosApi = {
  scenarios: (days = 90, groupBy: ScenarioGroupBy = 'week') =>
    api<TreasuryScenarios>(`/api/finance/treasury/scenarios?days=${days}&groupBy=${groupBy}`),
  spendSimulation: (amount: number, date: string, scenario: ScenarioCode) =>
    api<SpendSimulation>(
      `/api/finance/treasury/spend-simulation?amount=${encodeURIComponent(amount)}&date=${encodeURIComponent(date)}&scenario=${scenario}`,
    ),
  simulate: (body: EconomicSimulatorInput) =>
    api<EconomicSimulatorResult>('/api/finance/simulator', { method: 'POST', body: JSON.stringify(body) }),
}
